import { createContext } from 'react';

export type ReportInternalContextType = {
  featurePreview: boolean;
  toggleFeaturePreview?: () => void;
};

export const ReportInternalContext = createContext<ReportInternalContextType>({
  featurePreview: false,
});
